// Typography scale — Be Vietnam Pro tuned (Vietnamese diacritics-first)
// All sizes use rem so they scale with the root 14px set in styles.js:
//   xs=10px, sm=12px, md=14px, lg=16px, xl=18px, 2xl=20px, 3xl=24px, ...

export const typographyFoundation = {
  fonts: {
    heading: "'Be Vietnam Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    body: "'Be Vietnam Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    mono: "'JetBrains Mono', 'Fira Code', 'Cascadia Code', 'Courier New', monospace",
  },

  fontSizes: {
    '2xs': '0.625rem', // 8.75px  — badge micro-text
    xs: '0.714rem', // 10px    — captions, helper text
    sm: '0.857rem', // 12px    — secondary labels
    md: '1rem', // 14px    — body (root = 14px)
    lg: '1.143rem', // 16px    — prominent body
    xl: '1.286rem', // 18px    — card titles
    '2xl': '1.429rem', // 20px    — section titles
    '3xl': '1.714rem', // 24px    — page titles
    '4xl': '2.143rem', // 30px    — hero numbers
    '5xl': '2.571rem', // 36px    — hero headline
    '6xl': '3.429rem', // 48px    — display
  },

  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    // Aliases matching Chakra defaults so existing fontWeight="semibold" still works
    normal: 400,
  },

  lineHeights: {
    none: 1,
    tight: 1.25,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2,
    // Named by usage — looser than Inter defaults so Vietnamese diacritics
    // (ầ, ể, ỡ, ữ…) don't collide between lines.
    body: 1.65,
    heading: 1.3,
  },

  letterSpacings: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0em',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em',
  },

  // Heading defaults — applied to all h1-h6 via Chakra Heading component.
  // Be Vietnam Pro is slightly wider than Inter: keep negative tracking
  // only on larger sizes; small headings need normal tracking to stay legible.
  components: {
    Heading: {
      baseStyle: {
        fontWeight: 'semibold',
        lineHeight: 'heading',
      },
      sizes: {
        xs: { fontSize: 'sm', letterSpacing: 'normal', fontWeight: 'semibold' },
        sm: { fontSize: 'md', letterSpacing: 'normal', fontWeight: 'semibold' },
        md: { fontSize: 'xl', letterSpacing: 'tight' },
        lg: { fontSize: '2xl', letterSpacing: 'tight' },
        xl: { fontSize: '3xl', letterSpacing: 'tight' },
        '2xl': { fontSize: '4xl', letterSpacing: 'tighter', fontWeight: 'bold' },
      },
    },
    Text: {
      baseStyle: {
        lineHeight: 'body',
      },
    },
  },
};
